import React from 'react';
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import PricingPlans from '../components/PricingPlans';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <Header />
      <PricingPlans />
      <ContactUs />
      <Footer />
    </>
  );
};

export default Home;

